import { Fragment } from 'react'
import { NextPageContext } from 'next'
import { NextSeo } from 'next-seo'

import { CreatePolicyLayout } from '@/features/layouts'
import { SelectPolicy } from '@/features/policies/CreatePolicy/components'

import * as CreatePolicyServices from '@/features/policies/CreatePolicy/services'
import { PolicyOption } from '@/features/policies/CreatePolicy/types'
import withPage from '@/lib/page/withPage'
// import { redirectPage } from '@/lib/helpers'

type Props = {
  policyOptions: PolicyOption[]
  template: string
}

function SelectPolicyPage(props: Props) {
  const { policyOptions, template } = props

  return (
    <Fragment>
      <NextSeo title="Create Policy" />

      <CreatePolicyLayout withBgImage={true}>
        <SelectPolicy options={policyOptions} template={template} />
      </CreatePolicyLayout>
    </Fragment>
  )
}

export default withPage()(SelectPolicyPage)

type CreatePolicyGetInitialPropsContext = {
  userData: unknown
} & NextPageContext

SelectPolicyPage.getInitialProps = async (
  context: CreatePolicyGetInitialPropsContext,
) => {
  const { query, userData } = context

  const template = (query?.template || '') as string

  // if (template) {
  //   const policy = await CreatePolicyServices.createFirstStep({
  //     template,
  //     userData,
  //   })
  //   redirectPage({ path: `/create/policy/${policy.token}/1` }, context)
  // }

  const policyOptions = await CreatePolicyServices.getOptions({ userData })

  return {
    template,
    policyOptions,
  }
}
